import { useMutation } from 'react-query'
import { request } from '../request'

export const useAuthLogout = () => {
  return useMutation(() =>
    request({
      url: '/auth/logout',
      method: 'POST',
    }),
  )
}
